/**
 * Figma: the content header that sits above the KPI strip on a roster screen
 * (e.g. "Creators / The people who could fit best", "Finalized creators /
 * Creators locked into this campaign."). Shared across roster tabs.
 */
export function RosterScreenHeader({ title, subtitle }: { title: string; subtitle: string }) {
  return (
    <div>
      <h1 className="m-0 text-[22px]/[28px] font-medium text-foreground">{title}</h1>
      <p className="mt-1 text-body-sm-regular text-muted-foreground">{subtitle}</p>
    </div>
  );
}
